import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TodayRoutingModule } from './today-routing.module';
import { TodayComponent } from './components/today/today.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCardModule } from '@angular/material/card';
import { UserActionItemsListViewComponent } from './components/user-action-items-list-view/user-action-items-list-view.component';
import { UserActionItemDetailsComponent } from './components/user-action-item-details/user-action-item-details.component';
import { MatListModule } from '@angular/material/list';
import { TimeAgoModule } from 'app/pipes/time-ago/time-ago-pipe.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { StartCasePipeModule } from 'app/pipes/start-case/start-case-pipe.module';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormlyModule } from '@ngx-formly/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BorrowerContactMethodsComponent } from '../../../app/modules/today/components/user-action-item-details/borrower-contact-methods/borrower-contact-methods.component';
import { CallButtonModule } from 'app/borrower-header/call-button/call-button.module';
import { EmailButtonMenuModule } from 'app/messages/email-button-menu/email-button-menu.module';
import { SmsButtonMenuModule } from 'app/sms/sms-button-menu/sms-button-menu.module';
import { UserActionItemBorrowerPaneComponent } from './components/user-action-item-borrower-pane/user-action-item-borrower-pane.component';
import { BusinessPersonnelModule } from 'ng2-app/borrower-overview/business-personnel/business-personnel.module';
import { NotesModule } from 'ng2-app/notes/notes.module';
import { DynamicScreenHeightModule } from 'ng2-app/modules/directives/dynamic-screen-height/dynamic-screen-height.module';
import { MatDialogModule } from '@angular/material/dialog';
import { BorrowerValuesListSmartModule} from 'ng2-app/components/borrower-values-list-smart/borrower-values-list-smart.module';
import { MonthlyTotalsModule } from 'ng2-app/monthly-totals/monthly-totals.module';
import { BorrowerDocumentsModule } from 'ng2-app/documents/documents.module';
import { BorrowerPaneOverviewComponent } from './components/user-action-item-borrower-pane/borrower-pane-overview-component/borrower-pane-overview.component';
import { InfoRequestsModule } from '../borrower/components/borrower-details/workflow/workflow-tasks/info-requests.module';
import { UserEmailListViewComponent } from './components/user-email-list-view/user-email-list-view.component';
import { MessagesModule } from 'ng2-app/messages/messages.module';
import { UserSmsListViewComponent } from './components/user-sms-list-view/user-sms-list-view.component';
import { SmsModule } from 'ng2-app/sms/sms.module';
import { UserCallHistoryListViewComponent } from './components/user-call-history-list-view/user-call-history-list-view.component';
import { CallHistoryService } from 'app/services/call/call-history.service';
import { BorrowerStatusDisplayModule } from 'app/borrower-header/borrower-status-display/borrower-status-display.module';
import { StatusDisplayModule } from 'app/pipes/status-display/status-display-pipe.module';
import { PhoneModule } from 'app/pipes/phone/phone-pipe.module';
import { ApplicationCompleteStatusModule } from 'app/borrower-header/application-complete-status/application-complete-status.module';
import { BorrowerDoingBusinessAsNameModule } from 'app/borrower-header/borrower-doing-business-as-name/borrower-doing-business-as-name.module';
import { DocumentReviewComponent } from './components/user-action-item-details/action-item-types/document-review/document-review.component';
import { LetDirectiveModule } from 'ng2-app/modules/directives/let/let.directive.module';
import { BorrowerPaneDealsComponent } from 'ng2-app/modules/today/components/user-action-item-borrower-pane/borrower-pane-deals-component/borrower-pane-deals.component';
import { MatTableModule } from '@angular/material/table';
import { DealModule } from 'ng2-app/deal/deal.module';
import { TruncateModule } from 'ng2-app/pipes/truncate/truncate-pipe.module';
import {
  BorrowerActivityStreamModule
} from 'lendio-borrower/components/borrower-details/borrower-detail-tabs/borrower-activity-stream/borrower-activity-stream.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DocumentUpdateConfirmationDialogComponent } from './components/user-action-item-details/action-item-types/document-review/document-update-confirmation-dialog/document-update-confirmation-dialog.component';
import {SafeUrlPipeModule} from 'ng2-app/pipes/url/safe-url.module';
import { AlertModule } from 'app/components/alert/alert.module';

@NgModule({
  declarations: [
    BorrowerContactMethodsComponent,
    BorrowerPaneDealsComponent,
    BorrowerPaneOverviewComponent,
    DocumentReviewComponent,
    DocumentUpdateConfirmationDialogComponent,
    TodayComponent,
    UserActionItemBorrowerPaneComponent,
    UserActionItemDetailsComponent,
    UserActionItemsListViewComponent,
    UserCallHistoryListViewComponent,
    UserEmailListViewComponent,
    UserSmsListViewComponent,
  ],
  imports: [
    AlertModule,
    ApplicationCompleteStatusModule,
    BorrowerActivityStreamModule,
    BorrowerDocumentsModule,
    BorrowerDoingBusinessAsNameModule,
    BorrowerStatusDisplayModule,
    BorrowerValuesListSmartModule,
    BusinessPersonnelModule,
    CallButtonModule,
    CommonModule,
    DealModule,
    DragDropModule,
    DynamicScreenHeightModule,
    EmailButtonMenuModule,
    FormlyModule,
    InfoRequestsModule,
    LetDirectiveModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSidenavModule,
    MatTableModule,
    MatTabsModule,
    MessagesModule,
    MonthlyTotalsModule,
    NotesModule,
    PhoneModule,
    PhoneModule,
    SafeUrlPipeModule,
    ScrollingModule,
    SmsButtonMenuModule,
    SmsModule,
    StartCasePipeModule,
    StatusDisplayModule,
    TimeAgoModule,
    TodayRoutingModule,
    TruncateModule,
  ],
  providers: [
    CallHistoryService
  ]
})
export class TodayModule { }
